/**
 * doctorsHome — s123 (canvas "Orella Doctors & Clinicians Home", boards A–D, APPROVED 2026-10-29). The pure pieces of
 * the Doctors & Clinicians home (components/doctors/DoctorsHomeKit), here so gate check-doctors-home runs them.
 */
/** The PCP saved in Profile › Insurance as something the share flow can send to (needs an NPI), or null. PURE. */
export function pcpAsOffice(pcp) {
  if (!pcp || !pcp.npi) return null
  return {
    npi: String(pcp.npi), name: pcp.name || '', credential: pcp.credential || null, specialty: pcp.specialty || null,
    address: pcp.address ? { line1: pcp.address } : null, phone: pcp.phone || null, fax: pcp.fax || null,
    faxOnFile: !!pcp.fax, faxSource: pcp.fax ? 'nppes' : null,
  }
}

/** Initials for a tile: an Orella doctor's first/last, else the first letters of a directory name. PURE. */
export function tileInitials(d) {
  if (!d) return ''
  if (d.first_name || d.last_name) return `${(d.first_name || '')[0] || ''}${(d.last_name || '')[0] || ''}`.toUpperCase()
  const words = String(d.name || '').replace(/\b(dr|md|do|np|pa)\b\.?/gi, ' ').split(/[\s,]+/).filter(Boolean)
  return words.length ? `${words[0][0]}${words.length > 1 ? words[words.length - 1][0] : ''}`.toUpperCase() : ''
}

/** The next distance the Widen button offers (the Filters sheet's steps), or null at the widest. PURE. */
export function widerMiles(miles) {
  const steps = [5, 10, 25, 50]
  const n = Number(miles) || 0
  return steps.find((s) => s > n) || null
}

// s124 (Dr. Rami, build 91: "What's with the max 250 everywhere. We have millions of listings so maybe another reference
//   point (in your area for instance)"; copy doc ORELLA_CASE_HOME_COPY_v1 §5 APPROVED): the counts are OFFICES (one per
//   street address, groupOffices), and a list that reached the search cap is "many offices", never the cap as a number.
//   DIR_SECTION_CAP is DirectoryNearby's section `limit` (check-case-home CH-6 keeps the two equal).
export const DIR_SECTION_CAP = 250

export function officeCount(rows, groupOffices, cap = DIR_SECTION_CAP) {
  const list = Array.isArray(rows) ? rows : []
  return { offices: list.length ? groupOffices(list).length : 0, capped: list.length >= cap }
}
